import { InjectionToken } from '@angular/core';

export interface OcpDialogRef<T = unknown> {
  close: (result?: T) => void;
}

export const OCP_DIALOG_REF = new InjectionToken<OcpDialogRef>('OCP_DIALOG_REF');
